export const WALMART_QUARTERLY_OFFER_TYPE = 'REDEMPTION_GROUPEDWHOPPER';

type OfferGroupCandidate = {
  offers?: unknown[] | null;
};

type PartnerOfferMetadata = {
  partnerOfferType?: unknown;
};

const isPartnerOfferMetadata = (offer: unknown): offer is PartnerOfferMetadata =>
  typeof offer === 'object' && offer !== null;

/**
 * Identifies one child of the Walmart quarterly group from its CMS partner type.
 */
export const isWalmartQuarterlyOffer = (offer: unknown): boolean =>
  isPartnerOfferMetadata(offer) && offer.partnerOfferType === WALMART_QUARTERLY_OFFER_TYPE;

/**
 * Identifies the CMS-managed Walmart quarterly group from all of its current children.
 */
export const isWalmartQuarterlyOfferGroup = (item: OfferGroupCandidate): boolean => {
  const offers = item?.offers;
  return (
    Array.isArray(offers) &&
    offers.length > 0 &&
    offers.every(
      offer =>
        isPartnerOfferMetadata(offer) && offer.partnerOfferType === WALMART_QUARTERLY_OFFER_TYPE
    )
  );
};
